/**
 * Reads optional operation metadata off a service's OpenAPI schema.
 *
 * `ServiceBase.getOperation()` THROWS (`InternalException: No operation X`)
 * when the step's `operationKey` isn't a path in the service schema. That
 * happens whenever the tool definitions in `currentTools.ts` and the service
 * schema stored for the account drift apart — e.g. a service whose schema was
 * (re)provisioned with the wrong or an older document. The reads below are all
 * optional display/behaviour hints, but the throw escapes React's render and
 * unmounts the whole app, so a single stale operation blanks the flow editor.
 *
 * Degrade to the caller's default instead, and leave a breadcrumb in the
 * console so the underlying schema drift is still discoverable.
 */
export function readOperationMeta<T>(read: () => T, fallback: T): T {
  try {
    return read();
  } catch (e) {
    console.warn("Missing operation in service schema", e);
    return fallback;
  }
}
